module.exports = __webpack_public_path__ + "static/logo-thewitcher-dark-en@2x-56880c15e2ca9cb56d49b059b13bb942.png";